import { useDispatch, useSelector } from "react-redux";
import { setSessionExpired, setSpinnerLoading } from "../utility/Redux/modal";
import { useState } from "react";
import { selectToken } from "../utility/Redux/security";
import { useEffect } from "react";
import { selectPrefix, selectWidth } from "../utility/Redux/profile";
import MasterHelp from "../utility/component/modals/masterHelp";
import moment from "moment";
import { CallAPIPromise } from "../billing/common";
import { FormatNumber2 } from "../utility/functions/formatNumber";

const StockHelp = ({
  onRowClick,
  status,
  onClose,
  setItemMasterHelpStatus,
  partyDetails,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    height: "80%",
    width: "auto",
    padding: "2px",
    borderRadius: "8px",
    // Change the shadow color
    overflow: "hidden",
    backgroundColor: "white",
  };

  const [rows, setRows] = useState([]);
  const token = useSelector(selectToken);
  const [barcode, setBardCode] = useState("");
  const prefix = useSelector(selectPrefix);

  const windowWidth = useSelector(selectWidth);
  const columns = [
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 100
          : windowWidth <= 1280
          ? 100
          : 120,
      headerAlign: "center",
      align: "left",
      field: "DATE",
      renderCell: (p) => {
        return moment(p.value).format("DD-MM-YYYY");
      },
      renderHeader: (params) => <div>Date</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 70
          : windowWidth <= 1280
          ? 50
          : 70,
      headerAlign: "center",
      align: "left",
      field: "ORDER_NO",
      renderHeader: (params) => <div>Order</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 150
          : windowWidth <= 1280
          ? 120
          : 150,
      headerAlign: "center",
      align: "left",
      field: "NAME",
      renderHeader: (params) => <div>Party Name</div>,
    },
    {
      width:
        windowWidth <= 400
          ? 70
          : windowWidth <= 940
          ? 110
          : windowWidth <= 1280
          ? 110
          : 150,
      headerAlign: "center",
      align: "left",
      field: "MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },

    {
      width:
        windowWidth <= 400
          ? 50
          : windowWidth <= 940
          ? 130
          : windowWidth <= 1280
          ? 110
          : 300,

      headerAlign: "center",
      align: "right",
      field: "TOTAL",
      renderCell: (p) => {
        return <div>{p.value ? FormatNumber2(p.value) : ""}</div>;
      },
      renderHeader: (params) => <div>Total</div>,
    },
  ];
  const mobileColumns = [
    {
      width: 80,
      headerAlign: "center",
      align: "left",
      field: "DATE",
      renderCell: (p) => {
        return moment(p.value).format("DD-MM-YYYY");
      },
      renderHeader: (params) => <div>Date</div>,
    },
    {
      width: 60,
      headerAlign: "center",
      align: "left",
      field: "INVNO",
      renderHeader: (params) => <div>Invno</div>,
    },

    {
      width: 100,
      headerAlign: "center",
      align: "left",
      field: "CUSTOMER_MOBILE",
      renderHeader: (params) => <div>Mobile</div>,
    },

    {
      width: 100,

      headerAlign: "center",
      align: "left",
      field: "NAME",
      renderHeader: (params) => <div>Party Name</div>,
    },
  ];
  const [searchQuery, setSearchQuery] = useState("");
  const [fullList, setFullList] = useState([]);

  useEffect(() => {
    if (searchQuery) {
      const regex = /\d+/;

      const searchItems = fullList.filter((item) => {
        if (regex.test(searchQuery.substring(0, 1))) {
          return item.INVNO.toString().includes(searchQuery);
        } else {
          return item.CUSTOMER_NAME.toLowerCase().includes(
            searchQuery.toLowerCase()
          );
        }
      });

      setRows(searchItems);
    } else {
      setRows(fullList);
    }
  }, [searchQuery]);

  const dispatch = useDispatch();

  const getData = async () => {
    dispatch(setSpinnerLoading("Loading bill"));
    const data = {
      table_prefix: prefix,
      ACCOUNT_NO: partyDetails ? partyDetails?.ACCOUNT_NO : "",
    };
    CallAPIPromise("/api/stockorders/listStockOrders", data, token)
      .then((p) => {
        if (p.data.response[0]) {
          let list = [];
          const data = p.data.response;
          for (let i = 0; i < data.length; i++) {
            if (
              !data[i].PURCHASE_BILL_NO ||
              data[i].PURCHASE_BILL_NO === "0" ||
              data[i].PURCHASE_BILL_NO === 0
            ) {
              list.push({
                ...data[i],
                id: i + 1,
              });
            }
          }
          setFullList(list);
          setRows(list);
        }
      })
      .catch((error) => {
        if (error.response.data.name === "TokenExpiredError") {
          dispatch(setSessionExpired(true));
        }
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  useEffect(() => {
    if (status) {
      getData();
    }
  }, [status]);

  const width = useSelector(selectWidth);
  const col = width > 700 ? columns : mobileColumns;
  return (
    <>
      <div className="bg-white">
        <MasterHelp
          status={status}
          style={style}
          onClose={() => {
            setSearchQuery("");
            onClose();
            setRows([]);
          }}
          title={"Stock | Help"}
          columns={width > 700 ? columns : mobileColumns}
          list={rows}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          onRowClick={(p) => {
            setSearchQuery("");

            onRowClick(p);
            setRows([]);
          }}
          extraFilter={
            width > 764
              ? [
                  {
                    placeHolder: "Bar Code",
                    onChange: (value) => {
                      setBardCode(value);
                      const spilitValue = value.split(" ");

                      const isValid = spilitValue
                        ? spilitValue[0] && spilitValue[1]
                          ? true
                          : false
                        : false;
                      if (isValid) {
                        const barPrefix = spilitValue[0];
                        const companyPrefx = prefix.replace(/_.+_/, "");
                        if (companyPrefx === barPrefix) {
                          const inv = spilitValue[1];
                          setSearchQuery(inv);
                        } else {
                          setSearchQuery("");
                        }
                      } else {
                        setSearchQuery("");
                      }
                    },
                    value: barcode,
                    width: columns[3].width + columns[4].width + 20,
                    firstWidth:
                      columns[0].width + columns[1].width + columns[2].width,
                  },
                ]
              : false
          }
        />
      </div>
    </>
  );
};

export default StockHelp;
